import searchAnimation from "../../images/search-animation.gif";

export default theme => ({
    searchPage: {
        position: 'relative',
        paddingBottom: 50,
        '& > p': {
            opacity: .5,
            fontSize: 14,
            lineSpacing: '0.016em',
            fontFamily: 'Overpass',
            marginTop: 0,
            paddingTop: 24,
            marginBottom: 0,
            [theme.breakpoints.up('lg')]: {
                marginLeft: 80,
            },
        },
        '& .no-results': {
            paddingTop: 32,
            '& > p': {
                fontSize: 14,
                lineSpacing: '0.016em',
                fontFamily: 'Overpass',
                marginTop: 0,
                paddingTop: 24,
                marginBottom: 0,
                [theme.breakpoints.up('lg')]: {
                    marginLeft: 80,
                },
                '& a': {
                    color: theme.palette.primary.main,
                }
            },
        },
        '&::before': {
            content: '""',
            backgroundColor: 'white',
            position: 'absolute',
            zIndex: -1,
            width: '100vw',
            left: '50%',
            transform: 'translateX(-50%)',
            top: 0,
            bottom: 0,
        },
        '& .prod-category': {
            fontSize: 18,
            opacity: .5,
            lineHeight: 1.5,
            display: 'flex',
            flexDirection: 'row',
            fontWeight: 'normal',
            alignItems: 'flex-end',
            marginTop: 36,
            [theme.breakpoints.up('lg')]: {
                marginLeft: 80,
            },
            '&::after': {
                content: '""',
                height: 1,
                marginLeft: 30,
                backgroundColor: 'black',
                display: 'block',
                flex: '1 0 auto',
                marginBottom: 4,
            }
        },
        '& .sub-category': {
            padding: '20px 15px',
            backgroundColor: '#EDEDED',
            boxShadow: '0 4px 8px rgba(0,0,0,0.08)',
            [theme.breakpoints.up('lg')]: {
                marginLeft: 80,
            },
            '& h4': {
                margin: 0,
                fontSize: 18,
                letterSpacing: '0.016em',
                lineHeight: 1,
                color: theme.palette.primary.main,
                marginBottom: 40,
                fontWeight: 'normal',
            },
            '& img': {
                maxWidth: 55,
                marginLeft: 15,
                float: 'right',
                marginTop: -10,
            },
            '& a': {
                backgroundColor: theme.palette.secondary.contrastText,
                color: theme.palette.secondary.main,
                fontFamily: theme.headerFont,
                letterSpacing: '0.016em',
                lineHeight: 1.5,
                fontSize: 18,
                width: 140,
                borderRadius: 44,
                boxShadow: '0 3px 6px rgba(0,0,0,0.16)',
                margin: '0 auto 12px',
                display: 'table',
                textDecoration: 'none',
                transition: 'background-color .3s ease-in-out, color .3s ease-in-out',
                textAlign: 'center',
                padding: 8,
                '&:hover, &:focus': {
                    color: theme.palette.secondary.contrastText,
                    backgroundColor: theme.palette.secondary.main,
                }
            }
        }
    },
    searching: {
        opacity: '1 !important',
        fontSize: 18,
        textAlign: 'center',
        padding: '40px 0 40px',
        '&::before': {
            content: '""',
            backgroundImage: 'url('+searchAnimation+')',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'contain',
            width: 44,
            height: 44,
            backgroundSize: 'cover',
            display: 'inline-block',
            verticalAlign: 'middle',
            marginRight: 10,
        }
    },
    courseResults: {
        position: 'relative',
        paddingTop: 50,
        '& h2': {
            marginBottom: 50,
        },
        '& .course-titles': {
            display: 'none',
            [theme.breakpoints.up('md')]: {
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                fontFamily: "Roboto Condensed",
                letterSpacing: '0.152em',
                lineHeight: 1.2,
                fontSize: 12,
                textTransform: 'uppercase',
                '& .provider': {
                    flex: '0 0 10%',
                    minWidth: '10%',
                    padding: '0 12px 30px 0',
                },
                '& .title': {
                    flex: '0 0 30%',
                    minWidth: '30%',
                    padding: '0 12px 30px',
                },
                '& .places': {
                    flex: '0 0 20%',
                    minWidth: '20%',
                    padding: '0 12px 30px',
                },
                '& .category': {
                    flex: '0 0 15%',
                    minWidth: '15%',
                    padding: '0 12px 30px',
                },
                '& .length': {
                    flex: '0 0 10%',
                    minWidth: '10%',
                    padding: '0 12px 30px',
                },
                '& .dates': {
                    flex: '0 0 15%',
                    minWidth: '15%',
                    padding: '0 12px 30px',
                }
            },
            [theme.breakpoints.up('lg')]: {
                marginLeft: 80,
                '& .provider': {
                    flex: '0 0 12.5%',
                    minWidth: '12.5%',
                },
                '& .title': {
                    flex: '0 0 31.25%',
                    minWidth: '31.25%',
                },
                '& .places': {
                    flex: '0 0 12.5%',
                    minWidth: '12.5%',
                },
                '& .category': {
                    flex: '0 0 12.5%',
                    minWidth: '12.5%',
                },
                '& .length': {
                    flex: '0 0 6.25%',
                    minWidth: '6.25%',
                },
                '& .dates': {
                    flex: '0 0 25%',
                    minWidth: '25%',
                }
            }
        },
        '& .course-listing': {
            marginBottom: 32,
            [theme.breakpoints.up('md')]: {
                marginBottom: 80,
            },
            [theme.breakpoints.up('lg')]: {
                marginLeft: 80
            },
            '& .course-item': {
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                borderTop: '1px solid rgba(0,0,0,0.3)',
                backgroundColor: 'transparent',
                '&:nth-of-type(odd)': {
                    backgroundColor: 'white',
                },
                '& span.title': {
                    fontFamily: "Roboto Condensed",
                    letterSpacing: '0.152em',
                    lineHeight: 1.2,
                    fontSize: 12,
                    opacity: .3,
                    display: 'block',
                    marginBottom: 5,
                    textTransform: 'uppercase',
                    [theme.breakpoints.up('md')]: {
                        display: 'none',
                    }
                },
                '& .provider': {
                    flex: '0 0 100%',
                    minWidth: '100%',
                    padding: 12,
                    '& .gatsby-image-wrapper': {
                        width: 80,
                    }
                },
                '& div.title': {
                    flex: '0 0 100%',
                    minWidth: '100%',
                    padding: 12,
                    '& a': {
                        fontFamily: 'Overpass',
                        letterSpacing: '0.016em',
                        lineHeight: 1.5,
                        fontSize: 16,
                        fontWeight: 'bold',
                        color: theme.palette.primary.main,
                    }
                },
                '& .places': {
                    flex: '0 0 50%',
                    minWidth: '50%',
                    padding: 12,
                    fontFamily: 'Overpass',
                    letterSpacing: '0.016em',
                    lineHeight: 1.5,
                    fontSize: 16,
                    opacity: .5
                },
                '& .category': {
                    flex: '0 0 50%',
                    minWidth: '50%',
                    padding: 12,
                    fontFamily: 'Overpass',
                    letterSpacing: '0.016em',
                    lineHeight: 1.5,
                    fontSize: 16,
                    opacity: .5
                },
                '& .length': {
                    flex: '0 0 50%',
                    minWidth: '50%',
                    padding: 12,
                    fontFamily: 'Overpass',
                    letterSpacing: '0.016em',
                    lineHeight: 1.5,
                    fontSize: 16,
                    opacity: .5
                },
                '& .dates': {
                    flex: '0 0 50%',
                    minWidth: '50%',
                    padding: 12,
                    fontFamily: 'Overpass',
                    letterSpacing: '0.016em',
                    lineHeight: 1.5,
                    fontSize: 16,
                    opacity: .5
                },
                '& .link': {
                    flex: '0 0 100%',
                    minWidth: '100%',
                    padding: 12,
                    paddingBottom: 32,
                    '& a': {
                        display: 'table',
                        margin: '0 auto',
                        backgroundColor: 'white',
                        color: theme.palette.primary.main,
                        textTransform: 'uppercase',
                        fontFamily: theme.headerFont,
                        fontSize: 16,
                        lineHeight: 1.5,
                        borderRadius: 15,
                        boxShadow: '0 3px 6px rgba(0,0,0,0.16)',
                        textDecoration: 'none',
                        padding: '5px 20px',
                        transition: 'background-color .3s ease-in-out, color .3s ease-in-out',
                        '&:hover, &:focus': {
                            backgroundColor: theme.palette.primary.main,
                            color: theme.palette.primary.contrastText,
                        }
                    }
                },
                [theme.breakpoints.up('md')]: {
                    '& .provider': {
                        flex: '0 0 10%',
                        minWidth: '10%',
                        padding: '24px 12px 32px',
                    },
                    '& div.title': {
                        flex: '0 0 30%',
                        minWidth: '30%',
                        padding: '24px 12px 32px',
                    },
                    '& .places': {
                        flex: '0 0 20%',
                        minWidth: '20%',
                        padding: '24px 12px 32px',
                    },
                    '& .category': {
                        flex: '0 0 15%',
                        minWidth: '15%',
                        padding: '24px 12px 32px',
                    },
                    '& .length': {
                        flex: '0 0 10%',
                        minWidth: '10%',
                        padding: '24px 12px 32px',
                    },
                    '& .dates': {
                        flex: '0 0 15%',
                        minWidth: '15%',
                        padding: '24px 12px 32px',
                    }
                },
                [theme.breakpoints.up('lg')]: {
                    '& .provider': {
                        flex: '0 0 12.5%',
                        minWidth: '12.5%',
                    },
                    '& div.title': {
                        flex: '0 0 31.25%',
                        minWidth: '31.25%',
                    },
                    '& .places': {
                        flex: '0 0 12.5%',
                        minWidth: '12.5%',
                    },
                    '& .category': {
                        flex: '0 0 12.5%',
                        minWidth: '12.5%',
                    },
                    '& .length': {
                        flex: '0 0 6.25%',
                        minWidth: '6.25%',
                    },
                    '& .dates': {
                        flex: '0 0 12.5%',
                        minWidth: '12.5%',
                    },
                    '& .link': {
                        flex: '0 0 12.5%',
                        minWidth: '12.5%',
                        padding: '24px 12px 32px',
                    }
                }
            }
        }
    },
});